import React, { useContext, useState } from 'react';
import { AuthContext } from '../../App';
// Import icon SVG custom
import { PaketIcon, GiftIcon, UsersIcon, ClockIcon, UserPlusIcon } from '../../assets/icons';

const adminMenus = [
  { id: 'paket', label: 'Atur Paket', icon: PaketIcon },
  { id: 'kupon', label: 'Atur Kupon', icon: GiftIcon },
  { id: 'user', label: 'User Premium', icon: UsersIcon },
  { id: 'riwayat', label: 'Riwayat Kupon', icon: ClockIcon },
  { id: 'tambah-user', label: 'Tambah User Premium', icon: UserPlusIcon },
];

export default function AdminLayout({ activeTab, setActiveTab, children }) {
  const { logout, user } = useContext(AuthContext);
  const [showMenu, setShowMenu] = useState(false);
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex">
      {/* Sidebar admin (desktop) - fixed */}
      <aside className="hidden md:flex flex-col fixed top-0 left-0 h-screen w-56 bg-gradient-to-b from-blue-700 to-blue-900 text-white shadow-2xl z-40">
        <div className="h-20 flex items-center justify-center text-2xl font-bold tracking-wide border-b border-blue-800">ADMIN</div>
        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
          {adminMenus.map(menu => (
            <button
              key={menu.id}
              onClick={() => setActiveTab(menu.id)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 text-left group ${activeTab === menu.id ? 'bg-blue-600 text-white shadow-lg' : 'hover:bg-blue-800 text-blue-100 hover:text-white'}`}
            >
              <menu.icon className={`h-5 w-5 ${activeTab === menu.id ? 'text-white' : 'text-blue-200 group-hover:text-white'}`} />
              <span className="font-medium text-base">{menu.label}</span>
            </button>
          ))}
        </nav>
        {/* Logout button desktop */}
        <div className="px-4 pb-6 mt-auto">
          <button
            onClick={logout}
            className="w-full flex items-center justify-center gap-2 px-4 py-2 rounded-xl bg-red-600 hover:bg-red-700 text-white font-semibold shadow transition-all duration-200"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a2 2 0 01-2 2H7a2 2 0 01-2-2V7a2 2 0 012-2h4a2 2 0 012 2v1" /></svg>
            Logout
          </button>
        </div>
      </aside>
      {/* Main content */}
      <main className="flex-1 flex flex-col min-h-screen md:ml-56">
        {/* Mobile profile & logout */}
        <div className="md:hidden flex items-center gap-3 px-4 pt-4 pb-2">
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-100 text-blue-700 font-bold text-lg uppercase shadow">
            {user?.displayName?.[0] || 'A'}
          </div>
          <div className="flex-1">
            <div className="font-semibold text-gray-800 dark:text-gray-100 text-base">{user?.displayName || user?.email || 'Admin'}</div>
            <div className="text-xs text-gray-400 dark:text-gray-500">Admin</div>
          </div>
          <button
            onClick={logout}
            className="ml-auto px-3 py-2 rounded-lg bg-red-600 hover:bg-red-700 text-white font-semibold shadow transition-all duration-200 text-xs"
          >
            Logout
          </button>
        </div>
        <div className="flex-1 flex flex-col pb-24 md:pb-8 px-0 md:px-4 pt-2 md:pt-8 transition-all duration-200">
          {children}
        </div>
        {/* Bottom bar admin (mobile) - menu only */}
        <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white dark:bg-gray-900 border-t border-blue-200 dark:border-blue-800 flex justify-center items-center px-2 py-1 shadow-2xl md:hidden">
          <button
            onClick={() => setShowMenu(true)}
            className="flex flex-col items-center flex-1 py-2 focus:outline-none text-blue-600"
            aria-label="Menu Admin"
          >
            {/* Hamburger icon */}
            <svg className="w-8 h-8 mb-1" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M4 8h16M4 16h16" /></svg>
            <span className="text-xs font-semibold">Menu</span>
          </button>
        </nav>
        {/* Bottom sheet menu */}
        {showMenu && (
          <>
            {/* Overlay */}
            <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm" onClick={() => setShowMenu(false)} />
            {/* Bottom sheet */}
            <div className="fixed inset-x-0 bottom-0 z-50 bg-white dark:bg-gray-900 rounded-t-2xl shadow-2xl p-4 pb-8 animate-slide-up">
              <div className="w-12 h-1.5 bg-gray-300 dark:bg-gray-700 rounded-full mx-auto mb-4" />
              <div className="flex flex-col gap-2">
                {adminMenus.map(menu => (
                  <button
                    key={menu.id}
                    onClick={() => { setActiveTab(menu.id); setShowMenu(false); }}
                    className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 text-left group ${activeTab === menu.id ? 'bg-blue-100 dark:bg-blue-800 text-blue-700 dark:text-white shadow' : 'hover:bg-blue-50 dark:hover:bg-blue-800 text-gray-700 dark:text-gray-200'}`}
                  >
                    <menu.icon className={`h-6 w-6 ${activeTab === menu.id ? 'text-blue-700 dark:text-white' : 'text-blue-400 group-hover:text-blue-700 dark:group-hover:text-white'}`} />
                    <span className="font-medium text-base">{menu.label}</span>
                  </button>
                ))}
              </div>
              <button
                onClick={() => setShowMenu(false)}
                className="w-full mt-6 py-2 rounded-xl bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 font-semibold shadow hover:bg-gray-300 dark:hover:bg-gray-600 transition-all duration-200"
              >
                Tutup
              </button>
            </div>
            {/* Animasi slide up */}
            <style>{`
              .animate-slide-up { animation: slideUp .25s cubic-bezier(.4,0,.2,1); }
              @keyframes slideUp { from { transform: translateY(100%); opacity:0; } to { transform: translateY(0); opacity:1; } }
            `}</style>
          </>
        )}
      </main>
    </div>
  );
} 